
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPPreventivePumpHouseExportData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" rowSpan="2" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th rowSpan="2">Time</th>
                        <th colSpan="2" className='new_grid'>Voltage</th>
                        <th colSpan="2" className='new_grid'>Pump 1</th>
                        <th colSpan="2" className='new_grid'>Pump 2</th>
                        <th colSpan="2" className='new_grid'>Pump 3</th>
                        <th colSpan="2" className='new_grid'>Pump 4</th>
                        <th colSpan="2" className='new_grid'>Pump 5</th>
                        <th colSpan="2" className='new_grid'>Pump 6</th>
                        <th colSpan="2" className='new_grid'>Pump 7</th>
                        <th colSpan="2" className='new_grid'>Pump 8</th>
                        <th colSpan="2" className='new_grid'>Pump 9</th>
                        <th colSpan="2" className='new_grid'>Pump 10</th>
                        <th colSpan="2" className='new_grid'>Pump 11</th>
                        <th colSpan="2" className='new_grid'>Pump 12</th>
                        <th colSpan="2" className='new_grid'>Pump 13</th>
                        <th colSpan="2" className='new_grid' style={{ textAlign: "center", borderRight: "1px solid black" }}>Pump 14</th>
                    </tr>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>
                        <th className='new_grid'>HT</th>
                        <th className='new_grid'>LT</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th className='new_grid'>KWH</th>
                        <th className='new_grid'>AMP</th>
                        <th style={{ borderRight: "1px solid black" }}>KWH</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData && ExcelData.length > 0 ? ExcelData.map((i, j) => {
                            return (
                                <tr>
                                    <td style={{ textAlign: "center" }}>{j + 1}</td>
                                    <td>{i?.readingTime ? i?.readingTime : '-'}</td>
                                    <td>{i?.voltage_HT ? i?.voltage_HT : '-'}</td>
                                    <td>{i?.voltage_LT ? i?.voltage_LT : '-'}</td>
                                    <td>{i?.pump_AMP1 ? i?.pump_AMP1 : '-'}</td>
                                    <td>{i?.pump_KWH1 ? i?.pump_KWH1 : '-'}</td>
                                    <td>{i?.pump_AMP2 ? i?.pump_AMP2 : '-'}</td>
                                    <td>{i?.pump_KWH2 ? i?.pump_KWH2 : '-'}</td>
                                    <td>{i?.pump_AMP3 ? i?.pump_AMP3 : '-'}</td>
                                    <td>{i?.pump_KWH3 ? i?.pump_KWH3 : '-'}</td>
                                    <td>{i?.pump_AMP4 ? i?.pump_AMP4 : '-'}</td>
                                    <td>{i?.pump_KWH4 ? i?.pump_KWH4 : '-'}</td>
                                    <td>{i?.pump_AMP5 ? i?.pump_AMP5 : '-'}</td>
                                    <td>{i?.pump_KWH5 ? i?.pump_KWH5 : '-'}</td>
                                    <td>{i?.pump_AMP6 ? i?.pump_AMP6 : '-'}</td>
                                    <td>{i?.pump_KWH6 ? i?.pump_KWH6 : '-'}</td>
                                    <td>{i?.pump_AMP7 ? i?.pump_AMP7 : '-'}</td>
                                    <td>{i?.pump_KWH7 ? i?.pump_KWH7 : '-'}</td>
                                    <td>{i?.pump_AMP8 ? i?.pump_AMP8 : '-'}</td>
                                    <td>{i?.pump_KWH8 ? i?.pump_KWH8 : '-'}</td>
                                    <td>{i?.pump_AMP9 ? i?.pump_AMP9 : '-'}</td>
                                    <td>{i?.pump_KWH9 ? i?.pump_KWH9 : '-'}</td>
                                    <td>{i?.pump_AMP10 ? i?.pump_AMP10 : '-'}</td>
                                    <td>{i?.pump_KWH10 ? i?.pump_KWH10 : '-'}</td>
                                    <td>{i?.pump_AMP11 ? i?.pump_AMP11 : '-'}</td>
                                    <td>{i?.pump_KWH11 ? i?.pump_KWH11 : '-'}</td>
                                    <td>{i?.pump_AMP12 ? i?.pump_AMP12 : '-'}</td>
                                    <td>{i?.pump_KWH12 ? i?.pump_KWH12 : '-'}</td>
                                    <td>{i?.pump_AMP13 ? i?.pump_AMP13 : '-'}</td>
                                    <td>{i?.pump_KWH13 ? i?.pump_KWH13 : '-'}</td>
                                    <td>{i?.pump_AMP14 ? i?.pump_AMP14 : '-'}</td>
                                    <td>{i?.pump_KWH14 ? i?.pump_KWH14 : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>
            </table>
        </div>
    )
}